"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "debounce", {
    enumerable: true,
    get: function() {
        return debounce;
    }
});
function debounce(func, delay) {
    let timeoutId;
    function debounced(...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>func(...args), delay);
    }
    function cancel() {
        clearTimeout(timeoutId);
    }
    debounced.cancel = cancel;
    return debounced;
}
